// ПЕРВЫМ импортом и намеренно голым: token.ts на импорте модуля вычищает
// ?token= из адреса через history.replaceState (см. его докстринг), и это
// обязано случиться ДО createBrowserRouter, который снимает начальный location.
// Порядок исполнения статических импортов — это порядок их объявления, так что
// гарантия здесь спецификационная, а не случайная.
//
// Если бы роутер снял location раньше, токен остался бы в ЕГО представлении
// адреса, и первая же навигация, сохраняющая query-строку, вписала бы секрет
// обратно в адресную строку и в историю браузера — ровно та утечка, ради
// которой token.ts и написан.
import "./api/token";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "./components/ErrorBoundary";
import { router } from "./router";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Торговые данные приходят по сокету, а REST используется для справочников.
      // Автоматический refetch при фокусе окна здесь только мешает.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("не найден #root");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
